module.exports = __webpack_public_path__ + "img/thai-qr-payment.1db769d3.svg";